export interface IPkRateEntry {
  Installment: number
  InterestRate: number
}

// POS türü: değerler Banks.Flags ile aynıdır. 1 = Normal POS (bankanın kendi POS'u), 3 = AkÖde.
export type PkPosType = 1 | 3
export const PK_POS_NORMAL: PkPosType = 1
export const PK_POS_AKODE: PkPosType = 3
export const pkPosTypeLabel = (posType?: number | null): string =>
  posType === PK_POS_NORMAL ? 'Normal POS' : posType === PK_POS_AKODE ? 'AkÖde' : posType == null ? '' : String(posType)
// Çoklu tür gösterimi sabit sırayla: "AkÖde, Normal POS"
export const pkPosTypesLabel = (posTypes?: number[] | null): string =>
  [PK_POS_AKODE, PK_POS_NORMAL]
    .filter(t => (posTypes || []).includes(t))
    .map(pkPosTypeLabel)
    .join(', ')

// Normal POS'ta bu bankalar Akbank POS'una düştüğü için yalnız peşin (1) tanımlanabilir (BankCrud kuralı).
export const PK_NORMAL_POS_CASH_ONLY_BANK_IDS = [9001, 1402, 2701, 21402, 22701]

export interface IPkRateAdd {
  BankIds: number[]
  Company: number
  PosTypes: number[]
  Rates: IPkRateEntry[]
  StartDate: string
  EndDate: string
}

export interface IPkRateUpdate {
  Id: number
  InterestRate: number
  StartDate: string
  EndDate: string
}

export interface IPkRateBank {
  BankId: number
  BankName: string
}

export interface IPkRateRow {
  Id: number
  BankId: number
  BankName: string
  Installment: number
  InterestRate: number
  PosType: number
  StartDate: Date
  EndDate: Date
}

export interface IPkRateGroup {
  Guid: string
  Company: number
  PosTypes: number[]
  StartDate: Date
  EndDate: Date
  Banks: IPkRateBank[]
  Rates: IPkRateRow[]
  UserId: number
  UserName: string
  CreatedDate: Date
}

export interface IPkRateHistory {
  RateId?: number
  BankId: number
  BankName: string
  Installment: number
  InterestRate: number
  PosType?: number
  Company: number
  StartDate: Date
  EndDate: Date
  Guid: string
  ProcessInformation: string
  UserId: number
  UserName: string
  CreatedDate: Date
}

export interface IPkBank {
  BankName: string
  BankId: number
}

// 1 = İş günü, 2 = Takvim günü
export type PkDeadlineUnit = 1 | 2

export interface IPkSetting {
  PkPaymentEnabled: boolean
  InstallmentsEnabled: boolean
  // Taksit -> POS türü eşlemesi. İki liste kesişmez; hiçbirinde olmayan taksit kapalıdır (sunulmaz).
  NormalPosInstallments: number[]
  AkOdeInstallments: number[]
  InvoiceControlEnabled: boolean
  InvoiceDeadlineUnit: PkDeadlineUnit
  InvoiceDeadlineValue: number
  InvoiceRequiredInstallments: number[]
}

export interface IPkHierarchy {
  HierarchyCode: string
  Description: string
  Installments: number[]
}

export interface IPkSettingHistory {
  Source: string
  HierarchyCode?: string
  ProcessInformation: string
  OldValue?: string
  NewValue?: string
  UserId: number
  UserName: string
  CreatedDate: Date
}

// Datagate: Peşine Kontrat oranları şimdilik yalnız bu şirket için tanımlanır.
export const PK_COMPANY_DATAGATE = 1100

// Tarih-saat (yyyy-MM-ddTHH:mm, datetime-local) <-> API biçimi yardımcıları. Saat dilimi kayması olmasın diye
// yerel bileşenler kullanılır.
export const toDateTimeInput = (value?: Date | string | null): string => {
  if (!value) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

// Seçilen dakika gönderilir; bitişi o dakikanın sonuna (:59) çekme işi backend'dedir.
export const toApiDateTime = (value: string): string => `${value}:00`

export const formatDateTime = (value?: Date | string | null): string => {
  if (!value) return ''
  const d = new Date(value)
  return isNaN(d.getTime())
    ? ''
    : `${d.toLocaleDateString('tr-TR')} ${d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`
}

// 1..max taksit seçenekleri (min'den başlar)
export const installmentOptions = (min: number, max: number) =>
  Array.from({ length: max - min + 1 }, (_, i) => ({ value: min + i, label: `${min + i} Taksit` }))
